import UserConfig from "./UserConfig";

export default UserConfig;
